<template>
  <simple-image-page
    page-label="השקעה לטווח קצר"
     :img-src="require('@/assets/saving-zone/balance-money/balance-money-header-image.svg')"
     title="למי זה יכול להתאים?"
     text="אם יש לך כסף פנוי ששוכב בעו״ש, והתלבטת מה כדאי לעשות איתו, אפשר להכיר כמה אפשרויות ולהבין איך  לצאת לדרך. "
     :button-props="buttonProps"
  />
</template>

<script>
import { mapActions } from 'vuex';
import Segment from '@/Segment';
import SimpleImagePage from '@/base-components/SimpleImagePage';
import BalanceMoneyFlow from '../cashflow-app/personalized-savings/balance-money/BalanceMoneyFlow';

export default {
  name: 'BalanceMoneyPage',
  components: {
    SimpleImagePage,
  },
  created() {
    Segment.trackUserInteraction('BalanceMoneyPage_Entered');
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    buttonAction() {
      Segment.trackUserInteraction('BalanceMoneyPage_ClickedOpenModal');
      this.openModal({ component: BalanceMoneyFlow, props: { origin: 'MoneyFundPage' } });
    },
  },
  computed: {
    buttonProps() {
      return {
        title: 'אני רוצה לשמוע עוד',
        action: this.buttonAction,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../cashflow-app/personalized-savings/balance-money/balance-money-styles";

</style>
